import {AxiosError} from 'axios';

export type ErrorMap = {[index: string]: string[]};

const isArrayOfStrings = (v: unknown) => Array.isArray(v) && v.every((i) => typeof i === 'string');
const isValidObject = (o: object) => Object.values(o).every(isArrayOfStrings);

const mapErrors = (data: object) => {
  const errorMap: ErrorMap = {};
  for (const [k, v] of Object.entries(data)) {
    if (Array.isArray(v) && v.length > 0 && typeof v[0] === 'string') {
      errorMap[k] = v;
    } else if (typeof v === 'string') {
      errorMap[k] = [v];
    }
  }
  return errorMap;
};

export function errorResponseToErrorMap(error: unknown): ErrorMap {
  if (
    error instanceof AxiosError &&
    error.status !== undefined &&
    error.status >= 400 &&
    error.status <= 499 &&
    typeof error.response?.data === 'object'
  ) {
    if (error.response.data.detail) {
      // Custom error response with user-facing detail field and optional internal fields.
      // We only return the field meant to be displayed to the user.
      return {detail: [error.response.data.detail]};
    } else {
      return mapErrors(error.response.data);
    }
  }

  // TODO: Completely re-write errors in the front & back-ends
  if (typeof error === 'object' && error !== null && isValidObject(error)) return mapErrors(error);

  return {internal: ['Sorry, an unexpected error occurred.']};
}
